var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        _vm.showCategorySelection = false
      }
    }
  }, [_c('div', {
    staticClass: "menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("bioplan architekten")])], 1)]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "active",
    attrs: {
      "to": {
        name: 'Archive'
      }
    }
  }, [_vm._v("archiv")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Office'
      }
    }
  }, [_vm._v("büro")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("contact")])], 1)]), _vm._v(" "), (!_vm.currentEntry) ? _c('div', {
    staticClass: "search",
    attrs: {
      "role": "search"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    attrs: {
      "placeholder": "suche"
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.categories) ? _c('div', {
    staticClass: "categories",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(!_vm.showCategorySelection) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.showCategorySelection = true
      }
    }
  }, [(_vm.currentCategory) ? _c('span', {
    style: ({
      color: _vm.currentCategory.color
    })
  }, [_vm._v("\n          " + _vm._s(_vm.currentCategory.name) + "\n        ")]) : [_vm._v("\n          alle kategorien\n        ")], _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin": "0",
      "padding": "0"
    }
  }, [_vm._v("v")])], 2) : _c('div', {
    staticClass: "category-list"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.currentCategory = null;
        _vm.showCategorySelection = false
      },
      "mouseover": function($event) {
        _vm.currentCategory = null
      }
    }
  }, [_vm._v("alle Kategorien")])]), _vm._v(" "), _vm._l((_vm.categories), function(c) {
    return _c('li', [_c('a', {
      style: ({
        color: (c === _vm.currentCategory) ? _vm.currentCategory.color : 'white'
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.currentCategory = c;
          _vm.showCategorySelection = false
        },
        "mouseover": function($event) {
          _vm.currentCategory = c
        }
      }
    }, [_vm._v(_vm._s(c.name))])])
  })], 2)])]) : _vm._e()]), _vm._v(" "), (_vm.currentEntry) ? [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left font-regular"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.currentEntry.title) + "\n        ")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.markedEntryText)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    class: ("image-container " + _vm.imageLayoutOption)
  }, [(_vm.imageLayoutOption == 'layout-large-only' || _vm.imageLayoutOption == 'layout-medium-only' || _vm.imageLayoutOption == 'layout-small-only' || _vm.imageLayoutOption == 'layout-large-small' || _vm.imageLayoutOption == 'layout-large-medium') ? _vm._l((_vm.currentEntryImagesSorted), function(img) {
    return _c('img', {
      class: {
        'img-large': img.originalWidth >= 800, 'img-medium': img.originalWidth < 800 && img.originalWidth >= 550, 'img-small': img.originalWidth < 550
      },
      attrs: {
        "src": img.url
      }
    })
  }) : [_vm._l((_vm.currentEntryImagesLarge), function(img) {
    return _c('img', {
      staticClass: "img-large",
      attrs: {
        "src": img.url
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, _vm._l((_vm.currentEntryImagesMedium), function(img) {
    return _c('img', {
      staticClass: "img-medium",
      attrs: {
        "src": img.url
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, _vm._l((_vm.currentEntryImagesSmall), function(img) {
    return _c('img', {
      staticClass: "img-small",
      attrs: {
        "src": img.url
      }
    })
  }))]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "move-left",
    on: {
      "mouseup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        $event.stopPropagation();
        _vm.movePreviousEntry($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "move-right",
    on: {
      "mouseup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        $event.stopPropagation();
        _vm.moveNextEntry($event)
      }
    }
  })] : [(_vm.archiveLoading) ? _c('LoadingSpinner') : [_c('div', {
    staticClass: "archive-columns"
  }, _vm._l((_vm.columns), function(column) {
    return _c('div', {
      staticClass: "archive-column"
    }, [_vm._l((column), function(a) {
      return [(a.noDetails) ? [_c('div', {
        class: {
          'flex-item': true, 'in-filter': _vm.entryInFilter(a), 'no-details': a.noDetails
        },
        style: ({
          color: (_vm.entryInCurrentCategory(a)) ? _vm.currentCategory.color : 'inherit'
        })
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("\n                  " + _vm._s(a.title) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v("\n                  " + _vm._s(_vm._f("toMonthYearString")(a.date)) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "strikethrough",
        style: ({
          background: (_vm.entryInCurrentCategory(a)) ? _vm.currentCategory.color : (_vm.entryInFilter(a) ? 'red' : 'white')
        })
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])] : [_c('router-link', {
        class: {
          'flex-item': true, 'in-filter': _vm.entryInFilter(a), 'no-details': a.noDetails
        },
        style: ({
          color: (_vm.entryInCurrentCategory(a)) ? _vm.currentCategory.color : 'inherit'
        }),
        attrs: {
          "to": {
            name: 'ArchiveEntry',
            params: {
              id: a.id
            }
          },
          "tag": "div"
        }
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("\n                  " + _vm._s(a.title) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v("\n                  " + _vm._s(_vm._f("toMonthYearString")(a.date)) + "\n                ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])]]
    })], 2)
  }))]], _vm._v(" "), _vm._m(0)], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('img', {
    staticClass: "signet",
    attrs: {
      "src": require("../../assets/img/bioplan_signet.png"),
      "height": "57",
      "width": "72"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f988925","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Archive.vue
// module id = 172
// module chunks = 1